/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  FAILED_TO_PROCESS_REQUEST_EXCEPTION,
  NOT_AUTHORIZED_EXCEPTION,
  SERVER_IS_DOWN_EXCEPTION,
} from '/enum/errors.enum';
import {signOut} from '/redux/action/auth.action';
import {createPromisedAction} from '/util/action.util';

export const DISPLAY_ERROR = 'DISPLAY_ERROR';
export const HIDE_ERROR = 'HIDE_ERROR';

export const displayApiError = createPromisedAction(DISPLAY_ERROR, [
  'errorCode',
]);
export const hideApiError = createPromisedAction(HIDE_ERROR, ['errorCode']);

interface GetErrorHandlerParams {
  promisedAction: any;
  params: any;
  shouldSignOut: boolean;
  shouldRetry: boolean;
  sideAction: () => void;
}

export const getErrorHandler =
  (
    dispatch: (action: any) => void,
    {
      promisedAction,
      params,
      shouldSignOut = true,
      shouldRetry = true,
      sideAction,
    }: GetErrorHandlerParams,
  ) =>
  // @ts-expect-error TS(7030): Not all code paths return a value.
  (err: any) => {
    const {code: errorCode} = err;
    if (
      errorCode === SERVER_IS_DOWN_EXCEPTION ||
      errorCode === FAILED_TO_PROCESS_REQUEST_EXCEPTION
    ) {
      dispatch(displayApiError({errorCode}));
    } else if (err.code === NOT_AUTHORIZED_EXCEPTION) {
      if (shouldSignOut) {
        // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
        dispatch(signOut());
      }

      if (sideAction) {
        sideAction();
      }

      return {error: err, __meta: {shouldRetry}};
    }
  };
